module.exports = __webpack_public_path__ + "img/title-3.a02780ba.png";